/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useState } from 'react'

export const Context = React.createContext({})

const ModalProvider = ({ children }) => {
  const [state, setModalState] = useState({ isOpen: false, data: null })
  const openModal = data => {
    setModalState({ isOpen: true, data })
  }
  const closeModal = () => {
    setModalState({ isOpen: false, data: null })
  }
  return (
    <Context.Provider value={{ modal: { ...state, closeModal, openModal } }}>
      {children}
    </Context.Provider>
  )
}

export default ModalProvider
